function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { PureComponent } from 'react';
import Types from 'prop-types';
import classNames from 'classnames';
import { Check as CheckIcon } from '@transferwise/icons';
import debounce from 'lodash.debounce';
import Dropdown from '../../Dropdown';
import getTitleStringForLanguage from './languageSelectorTitles';
import parseLanguage from '../../../../../../../common/i18n/parseLanguage';
import normaliseLanguage from '../../../../../../../common/utils/normaliseLanugage';
var LanguageDropdown = /*#__PURE__*/function (_PureComponent) {
  _inherits(LanguageDropdown, _PureComponent);
  var _super = _createSuper(LanguageDropdown);
  function LanguageDropdown() {
    var _this;
    _classCallCheck(this, LanguageDropdown);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      hoverLanguage: _this.props.language
    });
    _defineProperty(_assertThisInitialized(_this), "onLanguageHover", debounce(function (hoverLanguage) {
      _this.setState({
        hoverLanguage: parseLanguage(hoverLanguage)
      });
    }, 150));
    return _this;
  }
  _createClass(LanguageDropdown, [{
    key: "getLanguageTitles",
    value: function getLanguageTitles() {
      var availableLanguages = this.props.availableLanguages;
      var hoverLanguage = this.state.hoverLanguage;
      return availableLanguages.map(function (_ref, index) {
        var language = _ref.value;
        var parsedLanguage = parseLanguage(language);
        var shouldShow = parsedLanguage === hoverLanguage;
        return /*#__PURE__*/React.createElement("span", {
          lang: normaliseLanguage(language),
          className: classNames('language-dropdown-title colored-dot', {
            active: shouldShow
          }),
          key: "".concat(parsedLanguage).concat(index) // eslint-disable-line
        }, getTitleStringForLanguage(parsedLanguage));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        availableLanguages = _this$props.availableLanguages,
        language = _this$props.language,
        onLanguageChange = _this$props.onLanguageChange,
        isOpen = _this$props.isOpen;
      return /*#__PURE__*/React.createElement(Dropdown, {
        className: classNames('tw-public-nav__dropdown-menu--lang', {
          hidden: !isOpen
        })
      }, /*#__PURE__*/React.createElement("li", {
        className: "dropdown-cta hidden-xs hidden-sm hidden-md"
      }, /*#__PURE__*/React.createElement("span", {
        className: "title-2 tw-public-nav__dropdown-content"
      }, this.getLanguageTitles())), availableLanguages.map(function (_ref2) {
        var value = _ref2.value,
          label = _ref2.label;
        return /*#__PURE__*/React.createElement("li", {
          key: value,
          onMouseEnter: function onMouseEnter() {
            return _this2.onLanguageHover(value);
          }
        }, /*#__PURE__*/React.createElement("button", {
          lang: normaliseLanguage(value),
          type: "button",
          className: "btn tw-public-nav__dropdown-content d-flex align-items-center",
          onClick: function onClick() {
            return onLanguageChange({
              value: value,
              label: label
            });
          }
        }, /*#__PURE__*/React.createElement("strong", {
          className: classNames({
            'text-info': language === parseLanguage(value)
          })
        }, label), language === parseLanguage(value) && /*#__PURE__*/React.createElement(CheckIcon, {
          className: "text-info"
        })));
      }));
    }
  }]);
  return LanguageDropdown;
}(PureComponent);
_defineProperty(LanguageDropdown, "defaultProps", {
  isOpen: false
});
export default LanguageDropdown;